import React from 'react';
import { selectCachedUserDataById } from '@/store/queries';
import { useAuth } from '@/providers/AuthProvider';
import { useSelector } from 'react-redux';

export const useHasRole = (roles: string[]) => {
  const { user } = useAuth();
  const userData = useSelector((state) => selectCachedUserDataById(state, user!.uid));

  const hasRole = roles.includes(userData?.role);

  return { hasRole, role: userData?.role };
};
